import { gql } from "@apollo/client";

export const GET_CITIES = gql`
  query GetCities($ids: [ID!]) {
    city {
      list(ids: $ids, version: V2) {
        id
        code
        name
      }
    }
  }
`;

export const GET_WARDS_OF_CITY = gql`
  query GetWardsOfCity($cityID: ID!) {
    ward {
      listOfCity(cityID: $cityID) {
        id
        code
        name
      }
    }
  }
`;

export const GET_BANKS = gql`
  query {
    bank {
      pagination {
        banks {
          id
          name
          fullName
        }
      }
    }
  }
`;
